<template>
  <div class="trail-list-item-media">
    <div class="container">
      <img class="image" :src="item.poster.portrait" />
      <div class="content" :id="item.id">
        <AppLogo name="full" color="#fff" data-depth="0.1" />
        <img class="title" :src="item.poster.title" data-depth="0.2" />
        <div class="stack" data-depth="0.3">
          <div class="item" v-for="stack in itemStack" :key="stack.id">
            <StackIcon
              :name="stack.name"
              color="#fff"
              background="light"
              size="40"
            />
          </div>
        </div>
        <div class="footer" data-depth="0.1">
          <div class="title">宁皓原创系列视频</div>
          <div class="meta">ninghao.co</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import AppLogo from '@/app/components/app-logo';
import Parallax from 'parallax-js';
import StackIcon from '@/stack/components/stack-icon';

export default defineComponent({
  name: 'TrailListItemMedia',

  /**
   * 属性
   */
  props: {
    item: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    itemStack() {
      let stacks = this.item.stacks;

      if (stacks && stacks.length > 6) {
        stacks = stacks.filter((item, index) => index < 3);
      }

      return stacks;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  mounted() {
    const scene = document.getElementById(this.item.id);
    new Parallax(scene);
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    AppLogo,
    StackIcon,
  },
});
</script>

<style scoped>
@import './styles/trail-list-item-media.css';
</style>
